import { Utils } from "@/plugins/utils"

const numericFields = ["fncposinic", "fncposfimc", "fncposini", "fncposfim", "fncposinid", "fncposfimd"]

function sanitizeFnc(fnc) {
	let sanitized = { ...fnc }
	numericFields.forEach(field => {
		if (sanitized[field] === "") sanitized[field] = null
	})
	return sanitized
}

export default {
	namespaced: true,
	state: {
		lstFnc: [],
		fnc: null,
		insert: false,
		update: false,
		loading: false,
		show: false,
	},
	getters: {
		getFnc: state => state.fnc,
		getLstFnc: state => state.lstFnc,
		getInsert: state => state.insert,
		getUpdate: state => state.update,
		getLoading: state => state.loading,
	},
	mutations: {
		set(state, fnc) {
			state.fnc = fnc
			state.insert = false
			if (fnc) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.fnc = null
			state.show = false
		},
		setLstFnc(state, lstFnc) {
			state.lstFnc = lstFnc
		},
		setLoading(state, loading) {
			state.loading = loading
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async findList({ commit, dispatch }, fncagente) {
			commit("setLoading", true)
			await this._vm.$axios
				.get(`/Financial/ReturnOccurrence/FindList/${fncagente}`)
				.then(response => {
					let lstFnc = Utils.ValidateAxiosResponse(response.data)
					commit("setLstFnc", lstFnc)
				})
				.catch(error => {
					commit("setLstFnc", [])
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
				})
			commit("setLoading", false)
		},
		async find({ commit, dispatch }, { fncagente, fncocorren }) {
			commit("setLoading", true)
			await this._vm.$axios
				.get(`/Financial/ReturnOccurrence/Find/${fncagente}/${fncocorren}`)
				.then(response => {
					let fnc = Utils.ValidateAxiosResponse(response.data)
					commit("set", fnc)
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
				})
			commit("setLoading", false)
		},
		save({ state, dispatch }) {
			if (state.update) {
				return dispatch("update")
			}
			return dispatch("insert")
		},
		async insert({ state, dispatch, commit }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios
				.post("/Financial/ReturnOccurrence/Insert", sanitizeFnc(state.fnc))
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					state.show = false
					dispatch("findList", state.fnc.fncagente)
					commit("set", null)
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ state, dispatch, commit }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios
				.put("/Financial/ReturnOccurrence/Update", sanitizeFnc(state.fnc))
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					state.show = false
					dispatch("findList", state.fnc.fncagente)
					commit("set", null)
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ dispatch }, { fncagente, fncocorren }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios
				.delete(`/Financial/ReturnOccurrence/Delete/${fncagente}/${fncocorren}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					dispatch("findList", fncagente)
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
	},
}
